import {CanActivateFn} from '@angular/router';

export const publicSlugGuard: CanActivateFn = (route) => {
  const slug = route.paramMap.get('slug');
  // Reject chunk and script assets
  return !slug?.endsWith('.js');
};
